import React from 'react';
import { number, bool, shape, oneOfType, string, element, func } from 'prop-types';
import cx from 'classnames';

import TranslatedCopy from '../../intl/translated-copy';

const RadioButton = ({
  className,
  isActive,
  isDisabled,
  isAttestation,
  onClick,
  option,
  optionIndex,
}) => {
  const buttonClasses = cx({
    'RadioButton': true,
    'is-buttonActive': isActive,
  }, className);

  const button = cx({
    'RadioButton-radio': true,
    'attestation-option': isAttestation ? true : false,
  });

  const optionClasses = cx({
    'CheckInAttestationForm-option': isAttestation ? true : false,
  });

  return (
    <button
      aria-disabled={ isDisabled }
      className={ buttonClasses }
      disabled={ isDisabled }
      onClick={ () => onClick(optionIndex, option.value) }
      type='button'>
      <div className='RadioButton-buttonContent'>
        <span className={ button } />
        <span className='RadioButton-buttonContentValue'>
          { option.copyID ?
            <TranslatedCopy
              className={ optionClasses }
              copyID={ option.copyID } />
            :
            option.label
          }
        </span>
      </div>
    </button>
  );
};

RadioButton.propTypes = {
  className: string,
  isActive: bool.isRequired,
  isDisabled: bool.isRequired,
  onClick: func.isRequired,
  option: shape({
    copyID: string,
    label: element,
    value: oneOfType([string, number]),
  }).isRequired,
  optionIndex: number.isRequired,
};

export default RadioButton;
